// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle_toggle__L3f2t","label":"Toggle_label__zvniT","inlineValue":"Toggle_inlineValue__v+6mf","checked":"Toggle_checked__gNC-c"};